import { enumScrollBarType } from "../constants";
import { QScrollBar } from "../CoreApp/QScrollBar";

export function AddFramelessScrollbarH(parent, portPanel) {
  parent.fScrollBarH = new QScrollBar();
  parent.PushElement(parent.fScrollBarH);
  parent.fScrollBarH.InitScrollBar(parent, portPanel, enumScrollBarType.horizontal);
  parent.fHasHorzScrollBar = false;
}
